export const sortOptionsList = (optionsList, selected) => {
    const selectedValues = new Set(selected.map((item) => item.value));
    return optionsList.sort((a, b) => {
        const aSelected = selectedValues.has(a.value) ? 0 : 1;
        const bSelected = selectedValues.has(b.value) ? 0 : 1;
        return aSelected - bSelected;
    });
};
//# sourceMappingURL=helpers.js.map